import { render, staticRenderFns } from "./PassengersListModal.vue?vue&type=template&id=0e66fc85&"
import script from "./PassengersListModal.vue?vue&type=script&lang=js&"
export * from "./PassengersListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports